// App.js
import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import NavBar from './NavBar';
import Text from './Text';
import Footer from './Footer';

const words = ["MY NAME IS SINEM", "I NEED TO GIVE Q WORDS", 'MAYBE LIKE', "TRANSCENDENCE", "IMPERMANENCE", "RESILIENCE", "METAMORPHOSIS", 'GO'];

function App() {
  const [isVolumeOn, setIsVolumeOn] = useState(false); // Sound is off by default

  const toggleVolume = () => {
    setIsVolumeOn(!isVolumeOn);
  };

  return (
    <div className="App">
      <NavBar />
      <div className="Text">
      <Text words={words} isVolumeOn={isVolumeOn} setIsVolumeOn={setIsVolumeOn} />
      </div>
      <Footer isVolumeOn={isVolumeOn} toggleVolume={toggleVolume} />
    </div>
  );
}

export default App;
